const generateErrorFromCode = (code, message = code, violationInfo = {}) => ({
  message,
  type: code,
  violationInfo,
});

const handleFormError = (error, setFormError = () => {}) => {
  const { code, message, status, violationInfo } = error;

  // if (errors && errors.length) {
  // TODO: Implement multierrors format
  // }

  setFormError([generateErrorFromCode(code || status, code || message, violationInfo)]);
  throw error;
};

export const handleFormSubmit =
  (action, dataFormatter = value => value) =>
  async (formData, { setGlobalErrors, setIsLoading }) => {
    const formattedData = dataFormatter(formData);

    if (formattedData === null) {
      return;
    }

    try {
      setIsLoading(true);
      const result = await action(formattedData);

      setIsLoading(false);

      return result;
    } catch (error) {
      setIsLoading(false);
      handleFormError(error, setGlobalErrors);
    }
  };
